import { makeVar } from '@apollo/client'

const defaultSearchQuery = ''

export const searchQueryVar = makeVar(defaultSearchQuery)
